<template>
  <li>
    <router-link :to="{ name: 'graduates.single', params: { id: graduate.id } }">
      <div class="row">
        <div class="col">
          <p class="strong">{{ graduate.name }}</p>
        </div>
        <div class="col-auto">
          <span v-if="graduate.overdue_task" class="status status-danger">Overdue</span>
          <span v-else-if="graduate.open_task && $userIsManager" class="status status-success">Open Task</span>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    graduate: {
      required: true,
      type: Object
    }
  }
}
</script>
